import React from "react";

const PlayStore = ({size = 24,  ...rest }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M5 19.9472V4.78123C5 3.41022 6.5633 2.5549 7.81069 3.24291L21.5495 10.8259C21.8305 10.9727 22.066 11.1937 22.2303 11.4649C22.3946 11.7361 22.4814 12.0472 22.4814 12.3642C22.4814 12.6813 22.3946 12.9923 22.2303 13.2635C22.066 13.5347 21.8305 13.7557 21.5495 13.9026L7.81194 21.4856C6.5633 22.1748 5 21.3183 5 19.9472Z"
                stroke="black"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <mask
                id="mask0_1484_2466"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="5"
                y="3"
                width="18"
                height="19"
            >
                <path
                    d="M5 19.9472V4.78123C5 3.41022 6.5633 2.5549 7.81069 3.24291L21.5495 10.8259C21.8305 10.9727 22.066 11.1937 22.2303 11.4649C22.3946 11.7361 22.4814 12.0472 22.4814 12.3642C22.4814 12.6813 22.3946 12.9923 22.2303 13.2635C22.066 13.5347 21.8305 13.7557 21.5495 13.9026L7.81194 21.4856C6.5633 22.1748 5 21.3183 5 19.9472Z"
                    fill="black"
                />
            </mask>
            <g mask="url(#mask0_1484_2466)">
                <path
                    d="M5.57935 3.49854L14.7569 11.9643L18.6152 15.523"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.54175 21.1794L14.7567 11.9644L17.9033 8.81787"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default PlayStore;
